/* eslint-disable */
import React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import { styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import DeleteButton from '@/components/button/delete';
import { CustomDeleteDialogProps } from "@/features/poc/datatables/interfaces";
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const SeriesFoliosTable = (
    {
        series
    }: any
): any => {
    const { t } = useTranslation()

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: '100%' }} aria-label="Series table" size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Serie</TableCell>
                            <TableCell align="left">Folio</TableCell>
                            <TableCell align="left">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            series && series.map((serie: any, index: number) => {
                                return (
                                    <StyledTableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell align="left" width={"50%"}>
                                            {serie.serie}
                                        </TableCell>
                                        <TableCell align="left" width={"50%"}>
                                            {serie.folio_siguiente}
                                        </TableCell>
                                        <TableCell>
                                            <DeleteButton />
                                        </TableCell>
                                    </StyledTableRow>
                                );
                            })
                        }
                        {
                            (series && series.length === 0) && (
                                <StyledTableRow>
                                    <TableCell align="center" colSpan={3}>
                                        {t("series.no_data")}
                                    </TableCell>
                                </StyledTableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default SeriesFoliosTable;